export default {
  TITTEL: {
    'nb-NO': 'Seniorlånkalkulator',
  },
  INGRESS: {
    'nb-NO': 'Vi tilbyr seniorlån på de fleste steder i Vestland og i Rogaland. Du ser enkelt hvor mye du kan få utbetalt ved å fylle ut skjemaet under.',
  },
  POSTSTED: {
    'nb-NO': 'Vi tilbyr seniorlån i {poststed}',
  },
  DU_KAN_FAA: {
    'nb-NO': 'Du kan få:',
  },
  KRITERIERTEKST: {
    'nb-NO': 'Beløpet utbetales som en engangssum og fordrer at oppgitte tall er riktig.',
  },
  UTENFOR_VESTLAND_OG_ROGALAND_TOOLTIP: {
    'nb-NO': 'Kun tilgjengelig i Vestland og Rogaland',
  },
  UTENFOR_ALLFARVEI: {
    'nb-NO': 'Vi tilbyr dessverre ikke Seniorlån der du bor',
  },
  POSTNUMMER_LABEL: {
    'nb-NO': 'Ditt postnummer',
  },
  BOLIGVERDI_LABEL: {
    'nb-NO': 'Boligens verdi',
  },
  BORETTSLAG_LABEL: {
    'nb-NO': 'Er det borettslagsleilighet?',
  },
  FELLESGJELD_LABEL: {
    'nb-NO': 'Fellesgjeld',
  },
  HOVEDLAANTAKER_ALDER_LABEL: {
    'nb-NO': 'Alder på hovedlåntaker',
  },
  MEDLAANTAKER_ALDER_LABEL: {
    'nb-NO': 'Alder på medlåntaker (hvis aktuelt)',
  },
  KAN_IKKE_FAA_LAAN_LAV_BOLIGVERDI: {
    'nb-NO': 'Grunnet for lav verdi på boligen din kan vi dessverre ikke tilby deg seniorlån.',
  },
  KAN_IKKE_FAA_LAAN_HØY_FELLESGJELD: {
    'nb-NO': 'Grunnet for høy fellesgjeld kan vi dessverre ikke tilby deg seniorlån.',
  },
  FINNER_IKKE_POSTNUMMER: {
    'nb-NO': 'Fant ingen sted med postnummer {postnummer}.',
  },
};
